<template>
  <IncomeConfirm
    top-page-id="mb041"
    previous-page-id="mb042"
    next-page-id="tem026"
  ></IncomeConfirm>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import IncomeConfirm from "@/components/fileupload/IncomeConfirm";

export default {
  name: "Mb043",
  components: {
    IncomeConfirm,
  },
  setup() {
    setMeta({
      title: "収入証明書のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,収入証明書",
    });
  },
};
</script>

<style scoped lang="scss"></style>
